require('./bootstrap');

import React from 'react';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { RouteContext } from '@/Hooks/useRoute';
import { ToastContextProvider } from './Hooks/toastContextProvider';

const appName = 'madeby.studio';

createInertiaApp({
  title: title => `${title} | ${appName}`,
  progress: {
    color: '#4B5563',
  },
  resolve: name => require(`./Pages/${name}`),
  setup({ el, App, props }) {
    createRoot(el).render(
      <RouteContext.Provider value={window.route}>
        <ToastContextProvider>
          <App {...props} />
        </ToastContextProvider>
      </RouteContext.Provider>,
      el,
    );
  },
});
